module.exports = __webpack_public_path__ + "static/img/JOSHUA-REICHELT.ae41974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JOSHUA-REICHELT.jpg
// module id = 4lAg
// module chunks = 0